import { animate, animation, style, transition, trigger, useAnimation } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Type, reflectComponentType } from '@angular/core';
import { DynamicDialogComponent as DynamicDialogComponentBase } from 'prime-ng-old/dynamicdialog';
import { DynamicDialogContent } from './dynamic-dialog-content';
import { UiIconsModule } from '../icons';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../icons/icon.component";
const _c0 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) => ({
  "p-dialog-mask": true,
  "p-dialog-mask-invisible": a0,
  "p-component-overlay p-component-overlay-enter p-dialog-mask-scrollblocker": a1,
  "p-dialog-left": a2,
  "p-dialog-right": a3,
  "p-dialog-top": a4,
  "p-dialog-bottom": a5,
  "p-dialog-top-left": a6,
  "p-dialog-top-right": a7,
  "p-dialog-bottom-left": a8,
  "p-dialog-bottom-right": a9
});
const _c1 = (a0, a1, a2, a3) => ({
  "p-dialog p-dynamic-dialog p-component": true,
  "p-dialog-rtl": a0,
  "p-dialog-resizable": a1,
  "p-dialog-draggable": a2,
  "p-dialog-maximized": a3
});
const _c2 = (a0, a1) => ({
  transform: a0,
  transition: a1
});
const _c3 = a0 => ({
  value: "visible",
  params: a0
});
function UiDynamicDialogComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("mousedown", function UiDynamicDialogComponent_Conditional_2_Conditional_2_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.initResize($event));
    });
    i0.ɵɵelementEnd();
  }
}
function UiDynamicDialogComponent_Conditional_2_Conditional_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiDynamicDialogComponent_Conditional_2_Conditional_3_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function UiDynamicDialogComponent_Conditional_2_Conditional_3_Conditional_3_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.hide());
    })("keydown.enter", function UiDynamicDialogComponent_Conditional_2_Conditional_3_Conditional_3_Conditional_3_Template_button_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.hide());
    });
    i0.ɵɵelement(1, "ui-icon", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngClass", "p-dialog-header-icon p-dialog-header-maximize p-link");
  }
}
function UiDynamicDialogComponent_Conditional_2_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵconditionalCreate(3, UiDynamicDialogComponent_Conditional_2_Conditional_3_Conditional_3_Conditional_3_Template, 2, 1, "button", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", ctx_r1.ariaLabelledBy + "_title");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.config.header);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.config.closable !== false ? 3 : -1);
  }
}
function UiDynamicDialogComponent_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14, 3);
    i0.ɵɵlistener("mousedown", function UiDynamicDialogComponent_Conditional_2_Conditional_3_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.initDrag($event));
    });
    i0.ɵɵtemplate(2, UiDynamicDialogComponent_Conditional_2_Conditional_3_ng_container_2_Template, 1, 0, "ng-container", 11);
    i0.ɵɵconditionalCreate(3, UiDynamicDialogComponent_Conditional_2_Conditional_3_Conditional_3_Template, 4, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r1.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.headerTemplate ? 3 : -1);
  }
}
function UiDynamicDialogComponent_Conditional_2_Conditional_6_ng_template_0_Template(rf, ctx) {}
function UiDynamicDialogComponent_Conditional_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiDynamicDialogComponent_Conditional_2_Conditional_6_ng_template_0_Template, 0, 0, "ng-template", 10);
  }
}
function UiDynamicDialogComponent_Conditional_2_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiDynamicDialogComponent_Conditional_2_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config.footer, " ");
  }
}
function UiDynamicDialogComponent_Conditional_2_Conditional_8_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiDynamicDialogComponent_Conditional_2_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵconditionalCreate(1, UiDynamicDialogComponent_Conditional_2_Conditional_8_Conditional_1_Template, 1, 1);
    i0.ɵɵtemplate(2, UiDynamicDialogComponent_Conditional_2_Conditional_8_ng_container_2_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.footerTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r1.footerTemplate);
  }
}
function UiDynamicDialogComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6, 1);
    i0.ɵɵlistener("@animation.start", function UiDynamicDialogComponent_Conditional_2_Template_div_animation_animation_start_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAnimationStart($event));
    })("@animation.done", function UiDynamicDialogComponent_Conditional_2_Template_div_animation_animation_done_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAnimationEnd($event));
    });
    i0.ɵɵconditionalCreate(2, UiDynamicDialogComponent_Conditional_2_Conditional_2_Template, 1, 0, "div", 7);
    i0.ɵɵconditionalCreate(3, UiDynamicDialogComponent_Conditional_2_Conditional_3_Template, 4, 2, "div", 8);
    i0.ɵɵelementStart(4, "div", 9, 2);
    i0.ɵɵconditionalCreate(6, UiDynamicDialogComponent_Conditional_2_Conditional_6_Template, 1, 0, null, 10);
    i0.ɵɵtemplate(7, UiDynamicDialogComponent_Conditional_2_ng_container_7_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(8, UiDynamicDialogComponent_Conditional_2_Conditional_8_Template, 3, 2, "div", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.config.styleClass);
    i0.ɵɵstyleProp("width", ctx_r1.config.width)("height", ctx_r1.config.height);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(19, _c1, ctx_r1.config.rtl, ctx_r1.config.resizable, ctx_r1.config.draggable, ctx_r1.maximized))("ngStyle", ctx_r1.config.style)("@animation", i0.ɵɵpureFunction1(27, _c3, i0.ɵɵpureFunction2(24, _c2, ctx_r1.transformOptions, ctx_r1.config.transitionOptions || "150ms cubic-bezier(0, 0, 0.2, 1)")));
    i0.ɵɵattribute("aria-labelledby", ctx_r1.ariaLabelledBy)("aria-modal", true);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.config.resizable ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1.config.showHeader === false ? false : true) ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.getContentClasses());
    i0.ɵɵproperty("ngStyle", ctx_r1.config.contentStyle);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.contentTemplate ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r1.contentTemplate);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.config.footer || ctx_r1.footerTemplate ? 8 : -1);
  }
}
const showAnimation = animation([style({
  transform: '{{transform}}',
  opacity: 0
}), animate('{{transition}}', style({
  transform: 'none',
  opacity: 1
}))]);
const hideAnimation = animation([animate('{{transition}}', style({
  transform: '{{transform}}',
  opacity: 0
}))]);
/**
 * Guide: https://www.primefaces.org/prime-ng-old/dynamicdialog
 * no need to add ui-dynmic-dialog component to template.
 * Mini Example:
 * Inject DynamicDialogService (provide in component!)
 * then use
 * const ref = dialogService.open(ComponentCtor, {
 *   header: 'Choose a Product',
 *   width: '70%',
 *   contentStyle: {"overflow": "auto"},
 *   baseZIndex: 10000,
 *   maximizable: true,
 *   data: {
 *     inputName:value
 *   }
 * })
 *
 * to get the dialog result, use:
 * ref.onClose.pipe(take(1)).subscribe(result=>{...})
 *
 * to access dialog state from within the dynamic component, inject DynamicDialogRef!
 *
 * The custom dynamic dialog supports binding inputs to same-named properties found in config.data!
 */
export let UiDynamicDialogComponent = /*#__PURE__*/(() => {
  class UiDynamicDialogComponent extends DynamicDialogComponentBase {
    getContentClasses() {
      return 'p-dialog-content' + (this.config.padded ? ' padded' : '');
    }
    loadChildComponent(componentType) {
      super.loadChildComponent(componentType);
      // TODO: replace when https://github.com/primefaces/prime-ng-old/issues/8383 is solved.
      // custom implementation for passing data object to component inputs
      // WARNING: As of angular 19, this does not work with aliased signal inputs!
      if (this.config.data) {
        // eslint-disable-next-line guard-for-in
        const meta = reflectComponentType(this.componentRef.componentType);
        meta.inputs.forEach(input => {
          if (typeof this.config.data[input.templateName] !== 'undefined') {
            this.componentRef.setInput(input.propName, this.config.data[input.templateName]);
          }
        });
      }
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiDynamicDialogComponent_BaseFactory;
        return function UiDynamicDialogComponent_Factory(__ngFactoryType__) {
          return (ɵUiDynamicDialogComponent_BaseFactory || (ɵUiDynamicDialogComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiDynamicDialogComponent)))(__ngFactoryType__ || UiDynamicDialogComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiDynamicDialogComponent,
        selectors: [["ui-dynamic-dialog"]],
        viewQuery: function UiDynamicDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(DynamicDialogContent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.insertionPoint = _t.first);
          }
        },
        hostAttrs: [1, "p-element"],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 15,
        consts: [["mask", ""], ["container", ""], ["content", ""], ["titlebar", ""], [3, "ngClass"], ["role", "dialog", 3, "ngClass", "ngStyle", "class", "width", "height"], ["role", "dialog", 3, "ngClass", "ngStyle"], [1, "p-resizable-handle", 2, "z-index", "90"], [1, "p-dialog-header"], [3, "ngStyle"], ["pDynamicDialogContent", ""], [4, "ngComponentOutlet"], [1, "p-dialog-footer"], [1, "p-resizable-handle", 2, "z-index", "90", 3, "mousedown"], [1, "p-dialog-header", 3, "mousedown"], [1, "p-dialog-title", 3, "id"], [1, "p-dialog-header-icons"], ["type", "button", "role", "button", 3, "ngClass"], ["type", "button", "role", "button", 3, "click", "keydown.enter", "ngClass"], ["icon", "times"]],
        template: function UiDynamicDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 4, 0);
            i0.ɵɵconditionalCreate(2, UiDynamicDialogComponent_Conditional_2_Template, 9, 29, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.config.maskStyleClass);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunctionV(4, _c0, [ctx.config.invisibleMask === true, ctx.config.modal !== false, ctx.position === "left", ctx.position === "right", ctx.position === "top", ctx.position === "bottom", ctx.position === "topleft" || ctx.position === "top-left", ctx.position === "topright" || ctx.position === "top-right", ctx.position === "bottomleft" || ctx.position === "bottom-left", ctx.position === "bottomright" || ctx.position === "bottom-right"]));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.visible ? 2 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgComponentOutlet, i1.NgStyle, UiIconsModule, i2.UiIconComponent, DynamicDialogContent],
        styles: ["@layer primeng{.p-dialog-mask{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;pointer-events:none}.p-dialog-mask.p-component-overlay{pointer-events:auto}.p-dialog{display:flex;flex-direction:column;pointer-events:auto;max-height:90%;transform:scale(1);position:relative}.p-dialog-content{overflow-y:auto;flex-grow:1}.p-dialog-header{display:flex;align-items:center;justify-content:space-between;flex-shrink:0}.p-dialog-draggable .p-dialog-header{cursor:move}.p-dialog-footer{flex-shrink:0}.p-dialog .p-dialog-header-icons{display:flex;align-items:center}.p-dialog .p-dialog-header-icon{display:flex;align-items:center;justify-content:center;overflow:hidden;position:relative}.p-fluid .p-dialog-footer .p-button{width:auto}.p-dialog-top .p-dialog,.p-dialog-bottom .p-dialog,.p-dialog-left .p-dialog,.p-dialog-right .p-dialog,.p-dialog-top-left .p-dialog,.p-dialog-top-right .p-dialog,.p-dialog-bottom-left .p-dialog,.p-dialog-bottom-right .p-dialog{margin:.75rem;transform:translateZ(0)}.p-dialog-maximized{transition:none;transform:none;width:100vw!important;height:100vh!important;top:0!important;left:0!important;max-height:100%;height:100%}.p-dialog-maximized .p-dialog-content{flex-grow:1}.p-dialog-left{justify-content:flex-start}.p-dialog-right{justify-content:flex-end}.p-dialog-top{align-items:flex-start}.p-dialog-top-left{justify-content:flex-start;align-items:flex-start}.p-dialog-top-right{justify-content:flex-end;align-items:flex-start}.p-dialog-bottom{align-items:flex-end}.p-dialog-bottom-left{justify-content:flex-start;align-items:flex-end}.p-dialog-bottom-right{justify-content:flex-end;align-items:flex-end}.p-dialog .p-resizable-handle{position:absolute;font-size:.1px;display:block;cursor:se-resize;width:12px;height:12px;right:1px;bottom:1px}.p-confirm-dialog .p-dialog-content{display:flex;align-items:center}}.p-dialog-mask{z-index:9000}.p-dialog-mask.p-dialog-mask-invisible{background-color:transparent;pointer-events:none}.p-dialog-wrapper{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;pointer-events:none}.p-dialog{pointer-events:auto;display:flex;flex-direction:column;width:800px;max-width:90%;border:var(--overlayContentBorder);border-color:var(--overlayContentBorderColor)}.p-dialog{padding:0;box-shadow:var(--dialogShadow)}.p-dialog .p-dialog-header{background-color:var(--panelHeaderAltBgColor);color:var(--panelHeaderAltTextColor);padding:1em;font-weight:400;border-bottom:0 none}.p-dialog .p-dialog-header .p-dialog-title{margin:0;float:none}.p-dialog .p-dialog-header .p-dialog-header-icon{color:var(--panelHeaderIconColor);border:0 none;padding:0;margin-left:.5em;transition:color .3s}.p-dialog .p-dialog-header .p-dialog-header-icon:hover{color:var(--panelHeaderIconHoverColor)}.p-dialog .p-dialog-content{background-color:var(--panelContentBgColor);color:var(--panelContentTextColor);border:var(--overlayContentBorder);border-color:var(--overlayContentBorderColor);padding:0;position:relative}.p-dialog .p-dialog-content.padded{padding:.571em 1em}.p-dialog .p-dialog-footer{border:0;border-color:transparent;border-top:0 none;background-color:var(--panelFooterBgColor);color:var(--panelFooterTextColor);padding:8px 10px;margin:0;text-align:right}.p-dialog .p-dialog-footer button{margin:0 .5em 0 0;width:auto}\n"],
        encapsulation: 2,
        data: {
          animation: [trigger('animation', [transition('void => visible', [useAnimation(showAnimation)]), transition('visible => void', [useAnimation(hideAnimation)])])]
        }
      });
    }
  }
  return UiDynamicDialogComponent;
})();